
import React, { useState, useEffect } from "react";
import './styles/index.css';
import { ToastProviderHotSonner } from "./components/ui/toastHotSonner";
import { Routes, Route, useLocation } from 'react-router-dom';
import { generateRoutes } from "./routes/routes";
import { AnimatePresence } from 'framer-motion';
import Transition from './components/atoms/animations/Transition';
import CookiesBanner from "./components/molecules/cookie/CookiesBanner"
import IdentityVerificationGate from "./components/IdentityVerificationGate";

const App: React.FC = () => {
  const location = useLocation();
  const shouldSkipLoader = (path: string) =>
    path.startsWith("/dashboard") ||
    path.startsWith("/pro/dashboard") ||
    path.startsWith("/etablissement/dashboard") ||
    path.startsWith("/etablissement/connexion") ||
    path.startsWith("/professionnel/connexion/code") ||
    path.startsWith("/professionnel/inscription") ||
    path.startsWith("/etablissement/inscription") ||
    path === "/patient" ||
    path.startsWith("/patient/") ||
    path.startsWith("/privacy-policy");
  const [transitioning, setTransitioning] = useState(
    () => !shouldSkipLoader(location.pathname)
  );

  useEffect(() => {
    const skipLoader = shouldSkipLoader(location.pathname);
    if (skipLoader) {
      setTransitioning(false);
      return;
    }
    setTransitioning(true);
    const timeout = setTimeout(() => setTransitioning(false), 2000); // doit correspondre à la durée dans Transition
    return () => clearTimeout(timeout);
  }, [location.pathname]);

  return (
    <div data-theme="previn" className="min-h-screen">
      <ToastProviderHotSonner />
      <IdentityVerificationGate />
      {transitioning && <Transition />}
      <AnimatePresence mode="wait" initial={false}>
        <Routes location={location} key={location.pathname}>
          {generateRoutes().map((route, index) => (
            <Route
              key={index}
              path={route.path}
              element={
                <>
                  <CookiesBanner />
                  {route.element}
                </>
              }
            />
          ))}
        </Routes>
      </AnimatePresence>
    </div>
  );
};

export default App;
